// BlogLayout.js
import BlogNavbar from "./BlogNavbar";
import { Outlet } from "react-router-dom";

export default function BlogLayout() {
  return (
    <>
      <BlogNavbar />
      <Outlet /> {/* This will render Blog list or Blog details */}
    </>
  );
}
